import { React, useState, useEffect } from "react";
import {
  Modal,
  Box,
  Stack,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Divider,
  Button,
  IconButton,
  TextField,
} from "@mui/material";
import { NoteOutlined, CloseOutlined } from "@mui/icons-material";
import DialogSuccess from "./dialogs/DialogSuccess";
import api from "../services/api";
import { getItemDecrypt } from "../utils/cryptoData";

const styles = {
  modal: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    // width: "50%",
    minWidth: "340px",
    maxWidth: "600px",
    height: "65hv",
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "4px",
    boxSizing: "border-box",
  },
  modalHeader: {
    backgroundColor: "#3E94C2",
    padding: "10px 15px 10px 15px",
    color: "#FFFFFF",
    fontSize: "20px",
    width: "100%",
    height: "50px",
    fontWeight: "600",
    lineHeight: "35px",
    borderRadius: 1,
  },
  container: {
    display: "flex",
    justifyContent: "center",
    alingItens: "center",
    height: "auto",
  },
  title: {
    fontWeight: "500",
    fontSize: "16px",
    lineHeight: "22px",
    color: "#063F5E",
  },
};

export default function ModalNota({
  openModal,
  setOpenModal,
  edit = false,
  dados = undefined,
  co_id,
  nu_status,
  notas = null,
  setNotas = () => {},
}) {
  const [assunto, setAssunto] = useState("");
  const [outroAssunto, setOutroAssunto] = useState("");
  const [descricao, setDescricao] = useState("");
  const [data, setData] = useState("");
  const [count, setCount] = useState(0);
  const [confirmAdd, setConfirmAdd] = useState(false);
  const [modalDelete, setModalDelete] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [confirmToArchive, setConfirmToArchive] = useState(false);
  const maxCaracteres = 250;

  const assuntoOpcoes = [
    "Consulta",
    "Medicamento",
    "Medicação e consulta",
    "Outros",
  ];

  // const vinculo = JSON.parse(localStorage.getItem("vinculo_ativo"));

  const vinculo = getItemDecrypt("vinculo_ativo");

  async function createNotas(params) {
    try {
      const response = await api.post("createNota", {
        id_autor_vinculo: vinculo.id,
        co_categoria_assunto: assunto,
        no_descricao: descricao,
        nu_status: "0",
      });
      let auxs = [...notas];
      auxs.push(response.data);
      setNotas(auxs);
      setOpenModal();
      setConfirmAdd(true);
    } catch (error) {
      console.error(error);
    }
  }

  async function updateNotas(params) {
    try {
      const response = await api.put("updateNota", {
        co_id: co_id ? co_id : 1,

        no_descricao: descricao,
      });

      const responseNotas = await api.post("getNota", { co_id: vinculo.id });

      setNotas(responseNotas?.data);

      setOpenModal();
      setConfirmAdd(true);
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0");
    var yyyy = today.getFullYear();

    today = dd + "/" + mm + "/" + yyyy;

    setData(today);

    if (dados) {
      setDescricao(dados.description);
      setCount(dados.description.length);
    }
  }, []);

  function handleSubmit() {
    if (edit === false) {
      createNotas();
    } else {
      updateNotas();
    }
  }

  async function handleArquivar() {
    setOpenModal();
    try {
      const response = await api.post("archiverNota", {
        co_id,
        nu_status: !Boolean(parseInt(nu_status)),
      });

      const responseNotas = await api.post("getNota", { co_id: vinculo.id });

      setNotas(responseNotas?.data);

      setConfirmToArchive(true);
    } catch (error) {
      console.error(error);
    }
  }

  function handleDelete(value) {
    if (value) {
      setOpenModal();
      setConfirmDelete(true);
    }
    setModalDelete(false);
  }

  function handleClose() {
    clearFields();
    setOpenModal();
  }

  function clearFields() {
    setAssunto("");
    setDescricao("");
    setOutroAssunto("");
    setCount(0);
  }

  return (
    <div>
      <Modal
        open={openModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        {edit ? (
          <Box sx={{ ...styles.modal, width: { xs: "80%", sm: "70%" } }}>
            <Box>
              <Stack
                direction={"row"}
                justifyContent={"space-between"}
                alignItems={"center"}
                style={styles.modalHeader}
              >
                <Stack direction={"row"} spacing={2} alignItems={"center"}>
                  <NoteOutlined fontSize="large" />
                  <span>Nota de {dados.data}</span>
                </Stack>
                <IconButton>
                  <CloseOutlined onClick={setOpenModal} />
                </IconButton>
              </Stack>
            </Box>
            <Box sx={{ padding: 3 }}>
              <Stack direction={"column"} spacing={2}>
                <Box>
                  <Stack direction={{ lg: "row", sm: "column" }} spacing={2}>
                    <Box style={{ width: "50%" }}>
                      <InputLabel style={styles.title}>Assunto</InputLabel>
                      <Box> {dados["title"]}</Box>
                    </Box>
                  </Stack>
                </Box>
                <Box>
                  <InputLabel required style={styles.title}>
                    Editar nota
                  </InputLabel>
                  <FormControl fullWidth>
                    <TextField
                      size="small"
                      multiline
                      rows={3}
                      value={descricao}
                      inputProps={{ maxLength: maxCaracteres }}
                      onChange={(event) => {
                        setDescricao(event.target.value);
                        setCount(event.target.value.length);
                      }}
                    >
                      {descricao}
                    </TextField>
                  </FormControl>
                </Box>
                <Box>
                  {count}/{maxCaracteres}
                </Box>
              </Stack>
              <Divider style={{ margin: "15px 0 15px 0" }} />
              <Stack direction={"row"} justifyContent={"space-between"}>
                <Button variant="outlined" onClick={handleArquivar}>
                  {nu_status === "0" ? "Arquivar" : "Desarquivar"}
                </Button>
                <Button
                  variant="outlined"
                  onClick={() => {
                    setModalDelete(true);
                  }}
                >
                  {" "}
                  Excluir{" "}
                </Button>
                <Button variant="contained" onClick={handleSubmit}>
                  {" "}
                  Salvar{" "}
                </Button>
              </Stack>
            </Box>
          </Box>
        ) : (
          <Box sx={styles.modal}>
            <Box>
              <Stack
                direction={"row"}
                justifyContent={"space-between"}
                alignItems={"center"}
                style={styles.modalHeader}
              >
                <Stack direction={"row"} spacing={2} alignItems={"center"}>
                  <NoteOutlined fontSize="large" />
                  <div>Adicionar nota de {data}</div>
                </Stack>
                <IconButton>
                  <CloseOutlined onClick={setOpenModal} />
                </IconButton>
              </Stack>
            </Box>
            <Box sx={{ padding: 3 }}>
              <Stack direction={"column"} spacing={2}>
                <Box>
                  <Stack direction={{ lg: "row", sm: "column" }} spacing={2}>
                    <Box style={{ width: "50%" }}>
                      <InputLabel required style={styles.title}>
                        Assunto
                      </InputLabel>
                      <FormControl fullWidth>
                        <Select
                          size="small"
                          displayEmpty
                          value={assunto}
                          onChange={(event) => {
                            setAssunto(event.target.value);
                          }}
                        >
                          {assuntoOpcoes.map((assuntoOpcoes, index) => {
                            return (
                              <MenuItem value={index + 1} key={index}>
                                {assuntoOpcoes}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </Box>
                    <Box style={{ width: "50%" }}>
                      {assunto === "Outros" ? (
                        <>
                          <InputLabel style={styles.title}>
                            Adicionar outro assunto
                          </InputLabel>
                          <FormControl fullWidth>
                            <TextField
                              size="small"
                              value={outroAssunto}
                              onChange={(event) => {
                                setOutroAssunto(event.target.value);
                              }}
                            >
                              {outroAssunto}
                            </TextField>
                          </FormControl>
                        </>
                      ) : (
                        <></>
                      )}
                    </Box>
                  </Stack>
                </Box>
                <Box>
                  <InputLabel required style={styles.title}>
                    Incluir nota
                  </InputLabel>
                  <FormControl fullWidth>
                    <TextField
                      multiline
                      rows={4}
                      size="small"
                      value={descricao}
                      inputProps={{ maxLength: maxCaracteres }}
                      onChange={(event) => {
                        setDescricao(event.target.value);
                        setCount(event.target.value.length);
                      }}
                    >
                      {descricao}
                    </TextField>
                  </FormControl>
                </Box>
                <Box>
                  {count}/{maxCaracteres}
                </Box>
              </Stack>
              <Divider style={{ margin: "15px 0 15px 0" }} />
              <Stack direction={"row"} justifyContent={"space-between"}>
                <Button variant="outlined" onClick={handleClose}>
                  {" "}
                  Cancelar{" "}
                </Button>
                <Button variant="contained" onClick={handleSubmit}>
                  {" "}
                  Salvar{" "}
                </Button>
              </Stack>
            </Box>
          </Box>
        )}
      </Modal>
      <DialogSuccess
        open={confirmAdd}
        onClose={() => setConfirmAdd(false)}
        variant={"success"}
        buttonAcceptText={""}
        buttonRejectText={""}
        text={"Nota salva com sucesso"}
      />
      <DialogSuccess
        open={modalDelete}
        onClose={handleDelete}
        variant={"error"}
        buttonAcceptText={"Sim"}
        buttonRejectText={"Não"}
        text={"Deseja realmente excluir a nota?"}
        subTitle={"Excluir nota"}
      />
      <DialogSuccess
        open={confirmDelete}
        onClose={() => setConfirmDelete(false)}
        variant={"success"}
        buttonAcceptText={""}
        buttonRejectText={""}
        text={"Nota excluída com sucesso"}
      />
      <DialogSuccess
        open={confirmToArchive}
        onClose={() => setConfirmToArchive(false)}
        variant={"success"}
        buttonAcceptText={""}
        buttonRejectText={""}
        text={
          nu_status === "0"
            ? "Nota arquivada com sucesso"
            : "Nota desarquivada com sucesso"
        }
      />
    </div>
  );
}
